import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 px-6 lg:px-12" data-id="element-55">
      {/* Background decorative blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-eucalipto/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-56"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-terracota/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000" data-id="element-57"></div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-58">
        <motion.div className="flex flex-col items-start space-y-8 order-2 lg:order-1" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-59">
          <div className="space-y-4" data-id="element-60">
            <motion.h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-dark leading-tight" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-61">
              Tu espacio para <br data-id="element-62" />
              <span className="text-eucalipto" data-id="element-63">sanar y crecer</span>
            </motion.h1>
            <motion.p className="text-lg md:text-xl text-medium max-w-lg leading-relaxed font-light" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-64">
              Acompañamiento profesional para transformar tu bienestar emocional
              en un entorno seguro y confidencial.
            </motion.p>
          </div>

          <motion.a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracota text-white px-8 py-4 rounded-full font-medium tracking-wide shadow-neumorph-sm hover:shadow-neumorph transition-all duration-300 hover:-translate-y-1" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-65">
            Agendar Sesión
          </motion.a>
        </motion.div>

        <motion.div className="relative order-1 lg:order-2 flex justify-center lg:justify-end" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.3
      }} data-id="element-66">
          <div className="relative w-full max-w-md aspect-[4/5] lg:aspect-square" data-id="element-67">
            <div className="absolute inset-0 bg-eucalipto/20 blob-shape transform translate-x-4 translate-y-4" data-id="element-68"></div>
            <img src="https://images.unsplash.com/photo-1586105251261-72a756497a11?w=800&q=80" alt="Entorno de consulta acogedor" className="relative z-10 w-full h-full object-cover blob-shape shadow-neumorph" data-id="element-69" />
          </div>
        </motion.div>
      </div>
    </section>;
}